module.exports = __webpack_public_path__ + "static/img/event-period-title.5d148a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/event-period-title.png
// module id = 0t2t
// module chunks = 1